export const UI_VERSION = "1.4.8";
export const DASHBOARD_STORAGE_KEY = "dashboard_widgets";
export const PAGE_SIZE = 20;
export const APP_ENVIRONMENT =
  process.env.REACT_APP_APP_ENVIRONMENT || "local";
